import { createWebHistory, createRouter } from "vue-router";
import Home from "../pages/home.vue";
const soldListings = () => import(/* webpackChunkName: "sold" */ "../pages/soldListings.vue");
const listingDetail = () => import(/* webpackChunkName: "listing-detail" */ "../pages/listingDetail.vue");
const reviews = () => import(/* webpackChunkName: "reviews" */ "../pages/reviews.vue");
const connections = () => import(/* webpackChunkName: "connections" */ "../pages/connections.vue");
const privacy = () => import(/* webpackChunkName: "privacy" */ "../pages/privacy.vue");
const Missing = () => import(/* webpackChunkName: "404" */ '../pages/404.vue');

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            name: "Home",
            component: Home,
            children: [
                {
                    path: "/sold",
                    name: "soldListings",
                    component: soldListings,
                },
                {
                    path: "/reviews",
                    name: "reviews",
                    component: reviews,
                },
                {
                    path: "/connections",
                    name: "connections",
                    component: connections,
                }
            ]
        },
        {
            path: "/sold",
            name: "soldListings",
            component: soldListings,
        },
        {
            path: "/reviews",
            name: "reviews",
            component: reviews,
        },
        {
            path: "/connections",
            name: "connections",
            component: connections,
        },
        {
            path: "/privacy",
            name: "privacy",
            component: privacy,
        },
        {
            path: "/:id",
            name: "listingDetail",
            component: listingDetail,
        },
        {
            path: "/:catchAll(.*)",
            name: "We cannot find what you are looking for",
            component: Missing,
        },
    ]
});
  
export default router;